module.exports = __webpack_public_path__ + "static/media/bundelkhand_region.41f9eabb.pdf";